import axios from "axios";
import { baseUrl, LOCAL_STORAGE_KEY } from "../Config";
import authHeader from "../Services/AuthHeader";

const instance = axios.create({
  baseURL: baseUrl,
});
let isAlertShown = false;
instance.interceptors.request.use((config) => {
  const token = authHeader();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      if (!isAlertShown) {
        alert("Session timed out!");
        isAlertShown = true;
        setTimeout(() => {
          localStorage.clear();
          window.location.reload();
        }, 1000);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
